/** @format */
import { useKeyPress } from '@mpb-com/feather/hooks';
import { RefObject, useState } from 'react';

import {
    Filter,
    FilterOption,
} from '@toucan/client/features/search/components/model-search-results/types';

export const useKeyboardInteractions = (
    optionsRef: RefObject<HTMLElement>,
    filter: Filter,
    handleSelect: (option: FilterOption) => void
) => {
    const [activeIndex, setActiveIndex] = useState<number>(-1);
    const options = filter.values;

    function setScrollPosition(ref: RefObject<HTMLElement>, position: number) {
        ref.current?.scrollTo({
            top: position,
            behavior: 'smooth',
        });
    }

    const optionHeight: number =
        (optionsRef?.current?.scrollHeight ?? 0) / (options?.length || 0);

    function clearActiveIndex() {
        setActiveIndex(-1);
    }

    useKeyPress(optionsRef.current, ['ArrowDown', 'Down'], (event) => {
        event.preventDefault();
        const hasFocus = optionsRef.current?.contains(document.activeElement);
        if (!filter || !hasFocus) {
            return;
        }
        const newIndex = (activeIndex + 1) % options.length;
        setActiveIndex(newIndex);
        setScrollPosition(
            optionsRef,
            newIndex * optionHeight - 3 * optionHeight
        );
    });

    useKeyPress(optionsRef.current, ['ArrowUp', 'Up'], (event) => {
        event.preventDefault();
        const hasFocus = optionsRef.current?.contains(document.activeElement);
        if (!filter || !hasFocus) {
            return;
        }
        const newIndex = (activeIndex - 1 + options.length) % options.length;
        setActiveIndex(newIndex);
        setScrollPosition(
            optionsRef,
            newIndex * optionHeight - 3 * optionHeight
        );
    });

    useKeyPress(optionsRef.current, [' ', 'Enter'], (event) => {
        event.preventDefault();
        const hasFocus = optionsRef.current?.contains(document.activeElement);
        if (!filter || !hasFocus) {
            return;
        }
        handleSelect(options[activeIndex]);
    });

    return {
        activeIndex,
        setActiveIndex,
        clearActiveIndex,
    };
};
